import { useSessionStore } from "@auth/sessionStore";
import { pimsAuditClient } from "@pims/pimsAuditClient";
import { useSuspenseQuery } from "@tanstack/react-query";

export const pimsAuditKeys = {
  /** Prefix for invalidating every PIMS audit query. */
  all: ["pimsAudit"] as const,
  detail: (clinicUuid: string, taskId: string) =>
    ["pimsAudit", clinicUuid, taskId] as const,
};

/**
 * The audit trail for one completed PIMS write (WEB-3237). Fetched lazily, only
 * once its card is expanded. Presigned screenshot URLs live ~1h, so the cache
 * is kept fresh well within that window; an expired URL past it is recovered by
 * refetching (an image `onError` in {@link PimsAudit} calls `refetch`), which
 * re-signs every URL server-side.
 */
export const usePimsAudit = (taskId: string) => {
  const clinicUuid = useSessionStore((s) => s.clinic?.clinicUuid ?? "");
  return useSuspenseQuery({
    queryKey: pimsAuditKeys.detail(clinicUuid, taskId),
    queryFn: () => pimsAuditClient.get(taskId),
    staleTime: 50 * 60 * 1000,
  });
};
